<template>
  <table class="table mt-0 mb-0 full-width">
    <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0">{{ $t('order.reminderType') }}</th>
        <th scope="col" class="border-0">{{ $t('status.reminderDate') }}</th>
        <th scope="col" class="border-0">{{ $t('status.receivers') }}</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(item, index) of emails"
        :key="'status-' + index">
        <td class="align-middle">
          <template v-if="item.type === 'WAITING_SAMPLE'">
            {{ $t('order.reminderTypeWaitingSample') }}
          </template>
          <template v-else-if="item.type === 'WAITING_ACCEPT'">
            {{ $t('order.reminderTypeWaitingAccept') }}
          </template>
          <template v-else-if="item.type === 'WAITING_PRODUCTION'">
            {{ $t('order.reminderTypeWaitingProduction') }}
          </template>
          <template v-else-if="item.type === 'WORKER_REMINDER'">
            {{ $t('order.reminderTypeWorkerReminder') }}
          </template>
          <template v-else-if="item.type === 'NEW_CUSTOMER_ORDER'">
            {{ $t('order.reminderTypeNewCustomerOrder') }}
          </template>
          <template v-else-if="item.type === 'WAITING_DRAFT'">
            {{ $t('order.reminderTypeDraft') }}
          </template>
          <template v-else-if="item.type === 'POD_REMINDER'">
            {{ $t('order.reminderTypePodReminder') }}
          </template>
          <template v-else-if="item.type === 'NO_SAMPLE_IN_INDENT'">
            {{ $t('order.reminderTypeNoSampleInIndent') }}
          </template>
          <template v-else-if="item.type === 'SAMPLE_NO_APPROVED_IN_INDENT'">
            {{ $t('order.reminderTypeSampleNotApprovedInIndent') }}
          </template>
          <template v-else-if="item.type === 'NO_SHIPPER_DATE_IN_INDENT'">
            {{ $t('order.reminderTypeNoShipperDateInIndent') }}
          </template>
        </td>
        <td class="align-middle">
          {{ item.created_at }}
        </td>
        <td class="align-middle">
          <div
            v-for="(receiver, index) of item.receivers"
            :key="'receiver-of-reminder-' + index"
            class="text-left">
            <small>
              {{ receiver.email }}
            </small>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'order-reminders',
  props: [
    'emails'
  ]
}
</script>
